import { api } from './index';
import type { User } from './users';
import type { Permission } from './permissions';

export type Role = {
  id: number;
  name: string;
  readableName?: string;
  description?: string;
  permissions: Permission[];
  users?: User[];
};

const BASE_PATH = '/api/internal/roles';

export const rolesApi = {
  // assignable: only the roles the current user may grant (every permission of the
  // role is one they hold), for the user form's role picker.
  index({ assignable = false }: { assignable?: boolean } = {}): Promise<Role[]> {
    return api({
      method: 'get',
      url: BASE_PATH,
      params: assignable ? { assignable: true } : undefined,
    }).then(response => response.data.roles);
  },
};
